import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { pick, filter, get, reduce, isString } from 'lodash';
import { TEXT, TEXTAREA } from './../../lib/custom-field-types';

import {
  savePurchaseConsumerFieldValues,
  showModalInnerAlert,
  projectPurchase,

  CLAIM_NAMESPACE,
} from '../../actions';
import Loading from '../../../components/loading';
import { formatContentWithEmoji } from '../../components/alert';
import {
  getConsumerFieldValues,
  getPurchaseConsumerFieldSchemas,
  getOrganizerMembership,
  getCurrentUserMembership,
} from '../../selectors/purchase-selector';
import noSchemasOrAllFieldsAreFilled from '../../lib/no-schemas-or-all-fields-are-filled';
import Membership from '../../lib/membership';
import Purchase from '../../lib/purchase';

import PurchaseConsumerFieldsComponent from '../../components/purchase-consumer-fields/index';
import { buildSpecialConsumerFieldInitialValues } from '../../lib/functions';
import { postComponentInfo } from '../../lib/iframe-messages';

class PurchaseConsumerFields extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      redirectTo: null,
    };
  }

  componentWillMount() {
    if (!this.isUserLoggedIn) return this.redirectToDashboard();
    if (!this.isClaimed) return this.redirectToClaim();
    if (!this.isCurrentUserOrganizer) return this.redirectToDashboard()
    if (this.props.noSchemasOrAllFieldsAreFilled) return this.redirectToDashboard();
    this.fetchProjections(this.props);
  }

  componentDidMount() {
    postComponentInfo('purchase-consumer-fields');
  }

  fetchProjections({ currentMembershipId, currentUserMembership }) {
    const { purchase } = this.props;

    const { minContribution, splitType } = purchase.group;
    const minSlots = purchase.productOrGroupMinSlots;
    const maxSlots = purchase.productOrGroupMaxSlots;
    const status = currentUserMembership ? currentUserMembership.status : null;
    const claimedSlots = Membership.isCommitted(status) ? currentUserMembership.claimedSlots : 1;
    const allowedShareAmount = get(currentUserMembership, 'allowedShareAmount', minContribution);
    const projectionParams = {
      id: this.props.purchase.id,
      group: {
        splitType,
        minSlots,
        maxSlots,
        minContribution,
      },
      memberships: [
        {
          id: currentMembershipId,
          claimedSlots,
          allowedShareAmount,
        },
      ],
    };

    if (Purchase.isGroupFull(purchase)) {
      projectionParams.memberships = [];
    }

    this.props.actions.projectPurchase(projectionParams, CLAIM_NAMESPACE);
  }

  onSubmit(data) {
    const { purchase, authentication } = this.props;
    const consumerFieldValues = this.props.consumerFieldSchemas.map(schema => {
      let value;

      try {
        value = isString(data[schema.name]) ? JSON.parse(data[schema.name]) : data[schema.name];
      } catch (e) {
        value = data[schema.name];
      }

      value = value === 'null' ? null : value

      if (!value && !schema.required) return null;

      return {
        schemaId: schema.id,
        value,
      }
    }).filter(fieldValue => !!fieldValue);

    this.props.actions.savePurchaseConsumerFieldValues(purchase.id, { consumerFieldValues }, authentication)
      .then(() => {
        window.location = this.afterSubmitRedirectUrl();
      })
      .catch((error) => {
        const content = formatContentWithEmoji(error.message, '‼️');
        this.props.actions.showModalInnerAlert(content);
      });
  }

  get isUserLoggedIn() {
    return !!get(this.props, 'authentication.token');
  }

  get isClaimed() {
    return this.props.organizerMembership;
  }

  get isCurrentUserOrganizer() {
    return this.props.isCurrentUserOrganizer;
  }

  afterSubmitRedirectUrl() {
    const { purchase } = this.props;
    return `/purchases/${purchase.slug}/organizer-commit`;
  }

  redirectToDashboard() {
    const { purchase } = this.props;
    this.setState({ redirectTo: `/purchases/${purchase.slug}/` });
  }

  redirectToClaim() {
    const { purchase } = this.props;
    this.setState({ redirectTo: `/purchases/${purchase.slug}/claim` });
  }

  render() {
    if (this.state.redirectTo) {
      window.location = this.state.redirectTo;
      return <Loading />;
    }

    const props = {
      ...pick(this.props, [
        'purchase',
        'consumerFieldSchemas',
        'initialValues',
      ]),
      onSubmit: this.onSubmit,
    };

    return (
      <PurchaseConsumerFieldsComponent {...props} />
    );
  }
}

const buildInitialValues = (schemas, values) => {
  return reduce(schemas, (initialValues, schema) => {
    const schemaValues = filter(values, { schemaId: schema.id });
    const defaultValue = schema.type === TEXT || schema.type === TEXTAREA ? null : schema.defaultValue;
    initialValues[schema.name] = get(schemaValues, '[0].value', defaultValue);

    return initialValues;
  }, {});
}

const mapStateToProps = state => {
  const { purchases, session } = state;
  const purchase = purchases.byId[purchases.current];
  const consumerFieldValues = getConsumerFieldValues(state) || [];
  const consumerFieldSchemas = getPurchaseConsumerFieldSchemas(state) || [];
  const organizerMembership = getOrganizerMembership(state);
  const currentUserMembership = getCurrentUserMembership(state)
  const isCurrentUserOrganizer = (organizerMembership && currentUserMembership) &&
    organizerMembership.id === currentUserMembership.id;
  let initialValues = buildInitialValues(consumerFieldSchemas, consumerFieldValues);

  const specialConsumerFieldValues = buildSpecialConsumerFieldInitialValues(consumerFieldSchemas);

  initialValues = { ...initialValues, ...specialConsumerFieldValues };

  return {
    authentication: session.authentication,
    purchase,
    consumerFieldSchemas,
    initialValues,
    organizerMembership,
    isCurrentUserOrganizer,
    noSchemasOrAllFieldsAreFilled: noSchemasOrAllFieldsAreFilled(consumerFieldSchemas, consumerFieldValues),
  };
};

const mapDispatchToProps = (dispatch) => {
  const containerActions = {
    savePurchaseConsumerFieldValues,
    showModalInnerAlert,
    projectPurchase,
  };

  return {
    actions: bindActionCreators(containerActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseConsumerFields);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-consumer-fields/index.container.js